<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const emit = defineEmits(['close', 'merge']);
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal
      class="tw-z-[100]"
      modal-class="tw-w-[800px]"
      @close="emit('close')"
    >
      <div class="tw-px-8 tw-pb-8 tw-flex tw-flex-col tw-gap-16 tw-justify-center">
        <div class="tw-flex tw-items-center tw-gap-4">
          <div class="tw-text-caution-700 tw-h-8 tw-w-8">
            <svg-vue icon="icons/warning" />
          </div>
          <h2 class="tw-text-2.5xl tw-text-neutral-900 tw-font-bold">
            Merge feedback?
          </h2>
        </div>

        <div class="tw-text-lg tw-text-neutral-900 tw-space-y-4">
          <p>
            You have highlighted a selection that already contains multiple bits of feedback.
          </p>
          <p>
            Continuing will result in the merging off all highlighted feedback items into a single
            piece of feedback for the whole selection.
          </p>
          <strong>This action cannot be undone</strong>
        </div>

        <div class="tw-flex tw-justify-end tw-items-center tw-gap-3">
          <DefaultButton @click="emit('close')">
            Cancel
          </DefaultButton>
          <DefaultButton
            variant="danger"
            @click="emit('merge')"
          >
            Merge
          </DefaultButton>
        </div>
      </div>
    </BaseModal>
  </Teleport>
</template>
